import React, { useState, useEffect, useContext } from 'react';
import { connect } from 'react-redux';
import { makeStyles } from '@material-ui/core/styles';
import { findSecComponents, findSecGroupComponents, saveGroupBooleans } from '../SecFunctions';
import FormControlLabel from '@mui/material/FormControlLabel';
import Checkbox from '@mui/material/Checkbox';
import SaveIcon from '@material-ui/icons/Save';
import Button from '@material-ui/core/Button';
import { handleError } from 'reducers/ErrorReducer';
import { notify } from 'reducers/NotifierReducer';
import { Fills } from 'utils/formStyles';
import { showSpinner, hideSpinner } from 'reducers/UiReducer';
import FormDivider from 'components/FormDivider';
import { MainPermissionContext } from '.';
import Alert from '@material-ui/lab/Alert';
import { getService } from 'reducers/service';

const useStyles = makeStyles(theme => ({
  checkStyle: {
    display: 'flex',
    flexDirection: 'row',
    flexWrap: 'wrap',
    padding: '5px',
  },
  checkStyleForpPlus: {
    border: `1px solid ${theme.colors.border}`,
    display: 'flex',
    flexDirection: 'row',
    flexWrap: 'wrap',
    padding: '5px',
    borderRadius: '15px',
    marginBottom: '10px',
  },
  item: {
    flex: '1 1 250px',
    margin: '5px',
  },
  saveBtn: {
    textAlign: 'right',
  },
}));
export const sortPPlusModules = data => {
  const mappedValues = { cad: 0, mobile: 1, rms: 2, settings: 3, 'incident archive': 4, analytics: 5, ams: 6, oms: 7 };
  const newArr = new Array(data.length).fill(0);
  data.forEach(item => {
    const position = mappedValues[item.Label.toLowerCase()];
    newArr[position] = item;
  });
  const processedData = newArr.filter(item => Boolean(item));
  return processedData;
};
function PermissionsApps(props) {
  const classes = useStyles();
  const {
    role,
    allComponents = [],
    allGroupComponents = [],
    refreshComponets,
    setRefreshComponent,
  } = useContext(MainPermissionContext);
  const [allModules, setAllModules] = useState([]);
  const [platinumPlusModules, setPlatinumPlusComponents] = useState([]);
  const [currentRoleWithModules, setCurrentRoleWithModules] = useState(null);
  const [existingModuleIds, setExistingModuleIds] = useState([]);
  const [initialLoad, setInitialLoad] = useState(true);
  const [licenseLimitErrors, setLicenseLimitErrors] = useState([]);
  const [moduleLicenseInfo, setModuleLicenseInfo] = useState({});

  useEffect(() => {
    fetchAndProcessData();
    setLicenseLimitErrors([]);
  }, [role]);

  const fetchAndProcessData = async () => {
    props.showSpinner();
    //fetch all components  and filterd by type modules

    const filteredComponets = allComponents.filter(c => c.Type === 'Modules');
    const p_plusModules = [];
    const other_modules = [];
    (filteredComponets || []).forEach(component => {
      if (component?.Flags?.trim() === 'P+') {
        p_plusModules.push(component);
      } else {
        other_modules.push(component);
      }
    });
    setAllModules(other_modules);
    const sortedPPlus = sortPPlusModules(p_plusModules);
    setPlatinumPlusComponents(sortedPPlus);

    // Fetch license info for P+ modules to display used/limit counts
    try {
      const licenseService = getService('license-validation');
      const infoPromises = sortedPPlus.map(m =>
        licenseService.get(m.ptsComponentID, { query: { moduleId: m.ptsComponentID } })
      );
      const licenseResults = await Promise.all(infoPromises);
      const infoMap = {};
      sortedPPlus.forEach((m, idx) => {
        const result = licenseResults[idx];
        if (result) {
          infoMap[m.ptsComponentID] = {
            usage: result.usage ?? 0,
            limit: result.limit,
            isOverLimit: result.isOverLimit ?? false
          };
        }
      });
      setModuleLicenseInfo(infoMap);
    } catch (e) {
      console.error('Error fetching license info:', e);
      setModuleLicenseInfo({});
    }

    //fetch all the permission groups and check if speficif component has permission checked or not

    const filtered = allGroupComponents.filter(
      el => el.ptsGroupID === role.ptsGroupID && el.Permissions === 1
    );
    //console.log('all group components ', allGroupComponents);
    const modules = [];
    for (const module of filteredComponets) {
      const found = filtered.find(el => module.ptsComponentID === el.ptsComponentID);
      if (found) modules.push(module.ptsComponentID);
    }

    const newRole = { ...role, Applications: modules };
    setCurrentRoleWithModules(newRole);

    const existingComponents = allGroupComponents.filter(el => el.ptsGroupID === role.ptsGroupID);
    const existingIds = [];
    for (const module of filteredComponets) {
      const found = existingComponents.find(el => module.ptsComponentID === el.ptsComponentID);
      if (found) existingIds.push(module.ptsComponentID);
    }
    setExistingModuleIds(existingIds);
    if (initialLoad) {
      props.hideSpinner();
      setInitialLoad(false);
    } else {
      setTimeout(() => {
        props.hideSpinner();
      }, 1000);
    }
  };

  const checkLicenseLimit = async (module, isAdding) => {
    if (!isAdding || module?.Flags?.trim() !== 'P+') {
      setLicenseLimitErrors(prev => prev.filter(e => e.moduleId !== module.ptsComponentID));
      return true;
    }

    try {
      const licenseService = getService('license-validation');
      const validation = await licenseService.create({
        action: 'validateRoleModule',
        groupId: role.ptsGroupID,
        moduleId: module.ptsComponentID,
        isAdding: true
      });

      if (!validation.allowed) {
        setLicenseLimitErrors(prev => {
          const filtered = prev.filter(e => e.moduleId !== module.ptsComponentID);
          return [...filtered, { moduleId: module.ptsComponentID, message: validation.message }];
        });
      } else {
        setLicenseLimitErrors(prev => prev.filter(e => e.moduleId !== module.ptsComponentID));
      }

      if (validation.projectedUsage != null && validation.limit != null) {
        setModuleLicenseInfo(prev => ({
          ...prev,
          [module.ptsComponentID]: {
            usage: validation.projectedUsage,
            limit: validation.limit,
            isOverLimit: validation.projectedUsage > validation.limit
          }
        }));
      }
      return validation.allowed;
    } catch (error) {
      console.error('Error checking license limit:', error);
      return true;
    }
  };

  const handleSaveClick = async () => {
    const data = {
      GroupId: role.ptsGroupID,
      ExistingComponents: existingModuleIds,
      CurrentComponents: currentRoleWithModules.Applications,
    };
    try {
      await saveGroupBooleans(data);
      setRefreshComponent(!refreshComponets);
      props.notify('Application Permissions Updated', 'success');
      // Refresh license info after save
      const licenseService = getService('license-validation');
      const infoPromises = platinumPlusModules.map(m =>
        licenseService.get(m.ptsComponentID, { query: { moduleId: m.ptsComponentID } })
      );
      const licenseResults = await Promise.all(infoPromises);
      const infoMap = {};
      platinumPlusModules.forEach((m, idx) => {
        const result = licenseResults[idx];
        if (result) {
          infoMap[m.ptsComponentID] = {
            usage: result.usage ?? 0,
            limit: result.limit,
            isOverLimit: result.isOverLimit ?? false
          };
        }
      });
      setModuleLicenseInfo(infoMap);
    } catch (err) {
      props.handleError(err, 'Error Updating Application Permissions');
    }
  };

  const handleChange = async module => {
    const newModulesIds = [...currentRoleWithModules.Applications];
    const foundIdx = newModulesIds.indexOf(module.ptsComponentID);
    const isAdding = foundIdx === -1;

    if (isAdding) {
      newModulesIds.push(module.ptsComponentID);
      checkLicenseLimit(module, true);
    } else {
      newModulesIds.splice(foundIdx, 1);
      setLicenseLimitErrors(prev => prev.filter(e => e.moduleId !== module.ptsComponentID));
      if (module?.Flags?.trim() === 'P+') {
        try {
          const licenseService = getService('license-validation');
          const validation = await licenseService.create({
            action: 'validateRoleModule',
            groupId: role.ptsGroupID,
            moduleId: module.ptsComponentID,
            isAdding: false
          });
          const projectedUsage = validation?.projectedUsage;
          const limit = validation?.limit ?? moduleLicenseInfo[module.ptsComponentID]?.limit;

          if (projectedUsage != null) {
            setModuleLicenseInfo(prev => ({
              ...prev,
              [module.ptsComponentID]: {
                usage: projectedUsage,
                limit: limit ?? prev[module.ptsComponentID]?.limit,
                isOverLimit: limit != null && projectedUsage > limit
              }
            }));
          } else {
            // Fallback: API returned only { allowed: true }, fetch current usage via get()
            try {
              const info = await licenseService.get(module.ptsComponentID, {
                query: { moduleId: module.ptsComponentID }
              });
              if (info) {
                setModuleLicenseInfo(prev => ({
                  ...prev,
                  [module.ptsComponentID]: {
                    usage: info.usage ?? 0,
                    limit: info.limit ?? prev[module.ptsComponentID]?.limit,
                    isOverLimit: info.isOverLimit ?? false
                  }
                }));
              }
            } catch (fallbackErr) {
              console.error('Error fetching fallback license info:', fallbackErr);
            }
          }
        } catch (e) {
          console.error('Error refreshing license info:', e);
        }
      }
    }

    const newRoleWithModules = { ...currentRoleWithModules, Applications: newModulesIds };
    setCurrentRoleWithModules(newRoleWithModules);
  };

  const handleChecked = module => {
    if (!currentRoleWithModules) return false;
    const currentModulesIds = [...currentRoleWithModules.Applications];
    const found = currentModulesIds.find(modId => modId === module.ptsComponentID);
    return Boolean(found);
  };
  const renderModule = module => {
    const isPPlus = module?.Flags?.trim() === 'P+';
    const isChecked = handleChecked(module);
    const licenseInfo = moduleLicenseInfo[module.ptsComponentID];
    const usage = licenseInfo?.usage ?? 0;
    const limit = licenseInfo?.limit;
    const isOverLimit = licenseInfo?.isOverLimit ?? false;

    // Always show usage/limit for P+ modules; when checked, usage reflects projected count
    const label = isPPlus && limit != null
      ? `${module.Label} (${usage}/${limit})`
      : module.Label;

    return (
      <FormControlLabel
        control={
          <Checkbox
            checked={isChecked}
            onChange={() => handleChange(module)}
            color="primary"
          />
        }
        label={
          <span style={isPPlus && isOverLimit ? { color: '#d32f2f', fontWeight: 600 } : undefined}>
            {label}
          </span>
        }
      />
    );
  };

  const renderSaveButton = () => {
    return (
      <div className={classes.saveBtn}>
        <Button 
          onClick={handleSaveClick} 
          variant="contained" 
          color="primary"
          disabled={licenseLimitErrors.length > 0}
        >
          <SaveIcon className="mr-2" /> Save
        </Button>
      </div>
    );
  };

  const renderLicenseErrors = () => {
    if (licenseLimitErrors.length === 0) return null;

    return (
      <div style={{ marginBottom: 16 }}>
        {licenseLimitErrors.map((error, idx) => (
          <Alert key={idx} severity="warning" style={{ marginBottom: 8 }}>
            {error.message}
          </Alert>
        ))}
      </div>
    );
  };

  return (
    <div>
      {renderLicenseErrors()}
      {renderSaveButton()}
      <FormDivider title="Platinum Plus" textOnly={true} />
      <div className={classes.checkStyleForpPlus}>
        {platinumPlusModules.map(m => (
          <span key={m.ptsComponentID} className={classes.item}>
            {renderModule(m)}
          </span>
        ))}
        <Fills className={classes.item} />
      </div>
      <FormDivider title="Others" textOnly={true} />

      <div className={classes.checkStyle}>
        {allModules.map(m => (
          <span key={m.ptsComponentID} className={classes.item}>
            {renderModule(m)}
          </span>
        ))}
        <Fills className={classes.item} />
      </div>
    </div>
  );
}

export default connect(null, { handleError, notify, showSpinner, hideSpinner })(PermissionsApps);
